/**
 * Maps PRESETS keys (from peptidePresets.ts) to product `drugFamilySlug` values
 * used in the catalog. Single source of truth so the patient protocol builder
 * can find the right preset for a given product.
 *
 * Presets without a matching catalog family aren't shown in the builder.
 * Catalog families without a preset (e.g. CJC-1295/Ipamorelin combo, Epitalon,
 * Thymosin Alpha-1) fall back to the existing dosageRecommender quiz on
 * educational pages and to a manual pick on the membership flow.
 */
export const PRESET_TO_FAMILY_SLUG: Record<string, string> = {
  semaglutide: 'semaglutide',
  tirzepatide: 'tirzepatide',
  retatrutide: 'retatrutide',
  sermorelin: 'sermorelin',
  tesamorelin: 'tesamorelin',
  ipamorelin: 'ipamorelin',
  bpc157: 'bpc157',
  tb500: 'tb500',
  ghk_cu: 'ghk-cu',
  nad: 'nad',
  motsc: 'mots-c',
  pt141: 'pt141'
};

export const FAMILY_SLUG_TO_PRESET: Record<string, string> = Object.fromEntries(
  Object.entries(PRESET_TO_FAMILY_SLUG).map(([k, v]) => [v, k])
);

export function presetKeyForFamilySlug(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return FAMILY_SLUG_TO_PRESET[slug];
}
